import React, { ReactNode } from 'react';
import Heading from 'elements/typography/heading';
import {
  BottomTextWrapper,
  CTAContainer,
  DescriptionParagraph,
  FeaturesList,
  PriceSubtitle,
  PricingBannerContainer,
  SubtitleWrapper
} from './PricingBanner.styles';
import Paragraph from 'elements/typography/paragraph';

export type PricingDisplayMode = 'monthly' | 'annual';

interface PricingBannerProps {
  title: string;
  subtitle?: string;
  description: string;
  bottomText?: string;
  cta: ReactNode;
  priceDisplayMode?: PricingDisplayMode;
  pricing?: {
    monthly?: number;
    annual?: number;
    monthlyDescription?: string;
    annualDescription?: string;
    featuresTitle: string;
    features: string[];
  };
}

const PricingBanner = (props: PricingBannerProps): JSX.Element => {
  const { title, bottomText, cta, description, subtitle, pricing, priceDisplayMode } = props;
  const displayPrice = priceDisplayMode === 'monthly' ? pricing?.monthly : pricing?.annual;
  const displayPriceDescription = priceDisplayMode === 'monthly' ? pricing?.monthlyDescription : pricing?.annualDescription;

  const priceInfoNode = pricing?.annual ?
    (
      <>
        <Heading text={`$${displayPrice}`} level={2} size="32px"/>
        <PriceSubtitle>{displayPriceDescription}</PriceSubtitle>
      </>
    ) :
    null;

  return (
    <PricingBannerContainer>
      <Heading text={title} size="24px" level={3}/>
      <SubtitleWrapper>
        <Heading text={subtitle} size="14px" level={4} fontFamily="Lato"/>
      </SubtitleWrapper>

      <DescriptionParagraph>
        {description}
      </DescriptionParagraph>

      <CTAContainer>
        {cta}
      </CTAContainer>

      {pricing && (
        <>
          <FeaturesList>
            <Heading text={pricing.featuresTitle} level={4} size="14px" fontFamily="Lato"/>

            {pricing.features.map(feature => (
              <li key={feature}><span>{feature}</span></li>
            ))}
          </FeaturesList>

          {priceInfoNode}
        </>
      )}

      {bottomText && (
        <BottomTextWrapper>
          <Paragraph text={bottomText} size="14px" weight="light" align="center"/>
        </BottomTextWrapper>
      )}
    </PricingBannerContainer>
  );
};

export default PricingBanner;
